var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2544 0.864773C12.1584 0.558835 11.132 0.889562 10.4026 1.55979C9.68445 2.21963 9.25 3.20576 9.25 4.26087V10.9554C9.25 12.2228 10.2775 13.2503 11.5449 13.2503H18.2394C19.2945 13.2503 20.2806 12.8158 20.9405 12.0977C21.6107 11.3683 21.9414 10.3419 21.6355 9.24587C20.5034 5.19027 17.31 1.99687 13.2544 0.864773ZM10.75 4.26087C10.75 3.60956 11.0201 3.02942 11.4175 2.66432C11.8035 2.30959 12.3035 2.15668 12.8511 2.30954C16.4013 3.30055 19.1997 6.099 20.1907 9.64917C20.3436 10.1968 20.1907 10.6967 19.8359 11.0828C19.4708 11.4801 18.8907 11.7503 18.2394 11.7503H11.5449C11.1059 11.7503 10.75 11.3944 10.75 10.9554V4.26087Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67232 4.21579C8.0675 4.09167 8.28724 3.6707 8.16312 3.27552C8.039 2.88034 7.61803 2.6606 7.22285 2.78472C3.18231 4.05378 0.25 7.82818 0.25 12.2894C0.25 17.7906 4.70962 22.2503 10.2108 22.2503C14.6721 22.2503 18.4465 19.3179 19.7155 15.2774C19.8397 14.8822 19.6199 14.4613 19.2247 14.3371C18.8296 14.213 18.4086 14.4328 18.2845 14.8279C17.2061 18.2613 13.9982 20.7503 10.2108 20.7503C5.53805 20.7503 1.75 16.9622 1.75 12.2894C1.75 8.50209 4.23899 5.29414 7.67232 4.21579Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/barChart.876c046794ce59e556366337db8403f7.svg";
export { ForwardRef as ReactComponent };